import { Group, Text, ActionIcon } from '@mantine/core';
import { IconArrowDown, IconArrowUp } from '@tabler/icons';

const LINK_COLOR = '#5C5CEB';

interface ExcerptNavigationProps {
  excerptCount: number;
  currentExcerptIndex: number;
  onJumpToFirst: () => void;
  onPrevious: () => void;
  onNext: () => void;
}

export function ExcerptNavigation({
  excerptCount,
  currentExcerptIndex,
  onJumpToFirst,
  onPrevious,
  onNext,
}: ExcerptNavigationProps) {
  const hasExcerpts = excerptCount > 0;

  return (
    <Group p="sm" bg="white" style={{ borderBottom: '1px solid #ddd', justifyContent: 'space-between' }}>
      <Text
        size="sm"
        c={hasExcerpts ? LINK_COLOR : 'dimmed'}
        style={{
          cursor: hasExcerpts ? 'pointer' : 'default',
          textDecoration: hasExcerpts ? 'underline' : 'none',
        }}
        onClick={hasExcerpts ? onJumpToFirst : undefined}
      >
        {hasExcerpts ? 'Jump to first excerpt' : 'No excerpts'}
      </Text>
      <Group style={{ gap: 4 }}>
        <ActionIcon
          variant="subtle"
          size="sm"
          onClick={onPrevious}
          disabled={!hasExcerpts || currentExcerptIndex <= 0}
          color="blue"
        >
          <IconArrowUp size={16} />
        </ActionIcon>
        <ActionIcon
          variant="subtle"
          size="sm"
          onClick={onNext}
          disabled={!hasExcerpts || currentExcerptIndex >= excerptCount - 1}
          color="blue"
        >
          <IconArrowDown size={16} />
        </ActionIcon>
      </Group>
    </Group>
  );
}
